import styled from '@emotion/styled';
import Image from 'next/image';
import arrow from './arrow.svg';
import { breakpointMedium } from '@/constants/breakpoints';
import { alphaHex, colors } from '@/constants/colors';
import checkImage from '@/public/images/ic-done.svg';

type StepperCircleProps = {
  currentStep: number,
  displayStepIndex: number,
  stepName: string,
  hideStepName?: boolean,
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Circle = styled.div<{ isCurrentStep: boolean }>`
  position: relative;
  display: flex;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ isCurrentStep }) => isCurrentStep ? 'transparent' : colors.black};
  background-color: ${({ isCurrentStep }) => isCurrentStep ? ` ${colors.blue}${alphaHex(0.15)}` : colors.white};
  border-radius: 50%;
`;

const CircleText = styled.div<{ isCurrentStep: boolean }>`
  color: ${({ isCurrentStep }) => isCurrentStep ? colors.blue : colors.black };
  font-size: 13px;
  font-weight: 700;
  line-height: 24px;
`;

const StepName = styled.span<{ isCurrentStep: boolean }>`
display: inline;
margin-left: 10px;
color: ${colors.black800};
font-size: 12px;
font-weight: 400;
line-height: 150%;
@media (max-width: ${breakpointMedium}) {
  display: none;
}
`;

const MobileStepName = styled.span`
position: absolute;
top: calc(100% + 12px);
display: none;
width: 70px;
color: ${colors.black800};
font-size: 12px;
font-weight: 500;
line-height: 17px;
text-align: center;
word-break: keep-all;
@media (max-width: ${breakpointMedium}) {
  display: inline;
}
`;

const StepArrow = styled.div`
padding-right: 25px;
padding-left: 17px;

@media (max-width: ${breakpointMedium}) {
  padding-right: 17px;
}
`;

const StepperItem = ({ currentStep, displayStepIndex, stepName, hideStepName }: StepperCircleProps) => {

  return (
    <Container>
      {displayStepIndex !== 1 && (
        <StepArrow>
          <Image src={arrow} alt="arrow" />
        </StepArrow>
      )}
      <Circle isCurrentStep={displayStepIndex === currentStep}>
        {displayStepIndex < currentStep
          ? <Image src={checkImage} alt="check" />
          : <CircleText isCurrentStep={displayStepIndex === currentStep}>{displayStepIndex}</CircleText>}
        {!hideStepName && <MobileStepName>{stepName}</MobileStepName>}
      </Circle>
      {!hideStepName && <StepName isCurrentStep={displayStepIndex === currentStep}>{stepName}</StepName>}
    </Container>
  );
};

export default StepperItem;
